let activeConsultation = null;

export function setConsultation(consultation) {
  activeConsultation = consultation;
}

export function getConsultation() {
  return activeConsultation;
}

let medical = null;

export function setMedical(height, weight) {
  if (height && weight) {
    medical = {
      height,
      weight,
    };
  } else {
    medical = null;
  }
}

export function getMedical() {
  return medical;
}

let baseUrl = null;
let prixaEngineBaseUrl = null;
let apiKey = null;
let partnerAppId = null;
let partnerId = null;
let qiscusAppId = null;
let voximplantAccountName = null;
let voximplantAppName = null;
export let APP_BASE_URL = null;
// export const BAYMAX_WIDGET_URL = "https://poc-widget.netlify.app";
export let BAYMAX_WIDGET_URL = null;

export function setDevMode(devMode) {
  if (devMode) {
    APP_BASE_URL = "https://dev.api.core.prixa.ai/api";
    BAYMAX_WIDGET_URL = "https://dev.baymaxwidget.prixa.ai";
    baseUrl = "https://dev.api.core.prixa.ai/api/v1/";
    prixaEngineBaseUrl = "https://dev.api.core.prixa.ai/api/v1/nalar/";
    apiKey = "WZQRQzxN6bDxkwb8Lr7b2liEIM5E22JY";
    partnerAppId = "e58b641d-5714-45d0-9453-af17f805dc74";
    partnerId = "2255079e-752b-486d-886b-c00be708b6a1";
    qiscusAppId = "pey-dkrupu7eb43nup2fe";
    voximplantAccountName = "prixa";
    voximplantAppName = "test";
  } else {
    APP_BASE_URL = "https://api.core.prixa.ai/api";
    BAYMAX_WIDGET_URL = "https://baymaxwidget.prixa.ai";
    baseUrl = "https://api.core.prixa.ai/api/v1/";
    prixaEngineBaseUrl = "https://api.core.prixa.ai/api/v1/nalar/";
    apiKey = "WZQRQzxN6bDxkwb8Lr7b2liEIM5E22JY";
    partnerAppId = "e58b641d-5714-45d0-9453-af17f805dc74";
    partnerId = "2255079e-752b-486d-886b-c00be708b6a1";
    qiscusAppId = "esca-cijfc7ux5zfcl924";
    voximplantAccountName = "prixa";
    voximplantAppName = "main";
  }
}

export function getBaseUrl() {
  return baseUrl;
}

export function getPrixaEngine() {
  return {
    prixaEngineBaseUrl,
    apiKey,
    partnerAppId,
    partnerId,
  };
}

export function getQiscusAppId() {
  return qiscusAppId;
}

export function getVoximplantAccountName() {
  return voximplantAccountName;
}

export function getVoximplantAppName() {
  return voximplantAppName;
}

// source: https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
export function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
